import './InfoBox.css'

export default function InfoBox(props) {
    return(
        <div className={`infobox ${props.isLeft? "left": "right"}`}>
            <h1 className='title'>{props.info.title}</h1>
            <div>
                <img 
                className={`infobox-image ${props.isLeft? "image-right": "image-left"}`} 
                alt={props.info.alt} src={props.info.image}/>
                <p dangerouslySetInnerHTML={{__html: props.info.text}}></p>
            </div>
        </div>
    );
}
